import { render, staticRenderFns } from "./RecipientRegistration.vue?vue&type=template&id=a3e58346"
import script from "./RecipientRegistration.vue?vue&type=script&lang=js"
export * from "./RecipientRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports